import * as yup from 'yup';
import { ptShort } from 'yup-locale-pt';
yup.setLocale(ptShort);

export const updateUserByManagerSchema = yup.object().shape({
    groups: yup.array(),
    meritMoneySchemeId: yup.string(),
    manager: yup.bool()    
});